let textField = document.querySelector('#player-name, #dog-name');
let dynamicCheckoutButton = document.querySelector('.shopify-payment-button');

if (textField === null) {
    dynamicCheckoutButton.style.display = 'block';
} else {
    textField.addEventListener('input', (event) => {
        let input = event.target.value.trim();
        if (input !== "") {
            dynamicCheckoutButton.style.display = 'block';
        } else {
            dynamicCheckoutButton.style.display = 'none';
        }
    });

    window.onload = function recoverDynamicCheckoutState() {
        let input = textField.value.trim();
        if (input !== "") {
            dynamicCheckoutButton.style.display = 'block';
        } else {
            dynamicCheckoutButton.style.display = 'none';
        }
    };
}
